module.exports = __webpack_public_path__ + "img/mail_bind_1.eef282be.png";